import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * X icon for representing close or remove actions
 */
export const XIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </Icon>
  );
};

export default XIcon;
